import { render } from "./floors_component.vue?vue&type=template&id=1fcbc3c7&scoped=true"
import script from "./floors_component.vue?vue&type=script&lang=js"
export * from "./floors_component.vue?vue&type=script&lang=js"

import "./floors_component.vue?vue&type=style&index=0&id=1fcbc3c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcbc3c7"]])

export default __exports__